<template>
  <el-dialog
    title="提示"
    :visible.sync="valueDialogShow"
    :show-close="showClose"
    :before-close="handleClose"
    width="80%"
  >
    <span style="color: #fff">{{ valueShow }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    valueDialogShow: {
      type: Boolean,
      default: false,
    },
    valueShow: {
      type: String,
      default: "请您在会议现场完成签到后申请开票!",
    },
  },
  data() {
    return {
      showClose: false,
    };
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialogs", false);
    },
    handleClose(done) {
      this.$emit("closeDialog1", done);
    },
  },
};
</script>

<style lang="scss" scoped></style>
